import { render, staticRenderFns } from "./ProfileSettings.vue?vue&type=template&id=1924b0e4&scoped=true"
import script from "./ProfileSettings.vue?vue&type=script&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&lang=js"
import style0 from "./ProfileSettings.vue?vue&type=style&index=0&id=1924b0e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1924b0e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1924b0e4')) {
      api.createRecord('1924b0e4', component.options)
    } else {
      api.reload('1924b0e4', component.options)
    }
    module.hot.accept("./ProfileSettings.vue?vue&type=template&id=1924b0e4&scoped=true", function () {
      api.rerender('1924b0e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Modal/ProfileSettings.vue"
export default component.exports